import * as React from 'react'
import { useMemo } from 'react'
import {
    AddFilled,
    AddRegular,
    ArrowDownloadFilled,
    ArrowDownloadRegular,
    bundleIcon,
    ColumnTripleFilled,
    ColumnTripleRegular,
    ListBarFilled,
    ListBarRegular,
} from '@fluentui/react-icons'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { BaseTaskOverviewProps, ExtendedTaskOverviewDto, TaskFilterType, TaskSortingType } from './BaseTaskOverview'
import { Button, Tooltip } from '@fluentui/react-components'
import { parseFilterValuesToParams } from '../BaseOverview/BaseOverview'
import useRoles, { Role } from '../../hooks/useRoles'
import useSubmitDocumentGenerationRequest from '../../hooks/finance/report/useSubmitDocumentGenerationRequest'
import { DocumentGenerationType } from '../../hooks/document/useDocumentGenerationHandler'
import { useFormikContext } from 'formik'
import { BaseOverviewFilterProps, ViewType } from '../BaseOverview/BaseOverviewFilter'
import useViewport, { Viewport } from '../../hooks/useViewport'

const AddIcon = bundleIcon(AddFilled, AddRegular)
const DownloadIcon = bundleIcon(ArrowDownloadFilled, ArrowDownloadRegular)

const ListViewIcon = bundleIcon(ListBarFilled, ListBarRegular)
const KanbanIcon = bundleIcon(ColumnTripleFilled, ColumnTripleRegular)

export default function HeaderActionsButtons(props: BaseOverviewFilterProps<ExtendedTaskOverviewDto, TaskFilterType, TaskSortingType>) {
    const history = useHistory()
    const roles = useRoles()
    const { t: translate } = useTranslation()
    const { values } = useFormikContext<TaskFilterType>()
    const { viewport, isViewport } = useViewport()

    const kanbanAvailable = useMemo<boolean>(() => isViewport('>=', Viewport.XXL), [viewport])
    const submitReportRequest = useSubmitDocumentGenerationRequest<TaskFilterType>(DocumentGenerationType.TaskXls)

    const taskProps = props as unknown as BaseTaskOverviewProps

    return (
        <>
            <Tooltip withArrow relationship={'label'} content={translate('action.create.task.title')}>
                <Button icon={<AddIcon />} appearance={'primary'} onClick={() => history.push(`${taskProps.baseUrl}/add`)} />
            </Tooltip>
            {roles.all([Role.Report]) && (
                <Tooltip withArrow relationship={'label'} content={translate('action.download.selection')}>
                    <Button icon={<DownloadIcon />} appearance={'secondary'} onClick={() => submitReportRequest(parseFilterValuesToParams(values))} />
                </Tooltip>
            )}
            {kanbanAvailable && (
                <Tooltip
                    withArrow
                    relationship={'label'}
                    content={translate(props.viewType === ViewType.KanbanView ? 'task.view.toggle.listview' : 'task.view.toggle.kanbanview')}
                >
                    <Button
                        icon={props.viewType === ViewType.KanbanView ? <ListViewIcon /> : <KanbanIcon />}
                        appearance={'secondary'}
                        onClick={() => props.setViewType(props.viewType === ViewType.KanbanView ? ViewType.ListView : ViewType.KanbanView)}
                    />
                </Tooltip>
            )}
        </>
    )
}
